import { type DefaultMessagesResponse, createPlacement } from '@post-office/placement-common-v2';
import { usePlacementApi } from '@post-office/use-placement-api';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren } from 'react';

export const { createFrontend, createBackend } = createPlacement({
	placementId: 'jira-nin-meatball-menu-button',
	options: {
		choreographer: {
			isDefaultEnabled: false,
		},
	},
});

export const PlacementFrontend = createFrontend<PropsWithChildren>((Messages) => ({ children }) => {
	const { data, error, isLoading } = usePlacementApi<DefaultMessagesResponse>('/');

	if (!children) {
		return null;
	}

	if (error || isLoading || data.messages.length === 0) {
		return <>{children}</>;
	}

	const [message] = data.messages;

	return <Messages.render {...message}>{children}</Messages.render>;
});

export const PlacementBackend = createBackend();
